export default "__VITE_ASSET__DVhvvx2$__"